import { AsyncPipe, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  FormErrorComponent,
  FormInputComponent,
  FormInputDirective,
  FormLabelDirective,
  FormSelectComponent,
} from '@app/base-components';
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from '@ng-select/ng-select';
import { BaseSiteToBrandService } from 'haba-base-components';
import { I18nModule, Title, TranslatePipe, TranslationService } from 'haba-core';
import { UserProfileFacade } from 'haba-featurelibs/user/profile/root';
import { sortTitles } from 'haba-storefrontlib';
import { Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-catalog-form',
  templateUrl: './catalog-form.component.html',
  styleUrls: ['./catalog-form.component.scss'],
  imports: [
    ReactiveFormsModule,
    NgIf,
    FormSelectComponent,
    FormLabelDirective,
    NgSelectComponent,
    FormErrorComponent,
    FormInputComponent,
    FormInputDirective,
    AsyncPipe,
    I18nModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    TranslatePipe,
  ],
})
export class CatalogFormComponent implements OnInit, OnDestroy {
  public catalogOrderForm: FormGroup;
  public titles$: Observable<Title[]>;
  public transCountrySub: Subscription;

  constructor(
    private fb: FormBuilder,
    private userProfileFacade: UserProfileFacade,
    private baseSite: BaseSiteToBrandService,
    private translation: TranslationService
  ) {
    const controls = {
      country: ['', Validators.required],
      titleCode: [undefined, Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      birthdate: ['', Validators.required],
      street: ['', Validators.required],
      houseNumber: ['', Validators.required],
      town: ['', Validators.required],
      postalCode: ['', Validators.required],
      email: ['', Validators.required],
    };

    this.catalogOrderForm = this.fb.group(controls);
  }

  ngOnInit(): void {
    this.titles$ = this.userProfileFacade
      .getTitles()
      .pipe(map((titles) => titles.sort(sortTitles)));
    this.transCountrySub = this.baseSite
      .currentCountryCode()
      .pipe(switchMap((country) => this.translation.translate('countries.' + country)))
      .subscribe((result) => {
        this.catalogOrderForm.controls.country.setValue(result);
      });
  }

  ngOnDestroy(): void {
    this.transCountrySub?.unsubscribe();
  }
}
